import { jsx as _jsx } from "react/jsx-runtime";
import { isEmpty, isNil, map, reduce } from "ramda";
import { RouteProvider } from "@/hooks/useRoute";
export function makeRouteObject(routes, dispatch) {
    return map((route)=>{
        var _route_meta, _route_meta1;
        let children = isNil(route.children) ? undefined : makeRouteObject(route.children, dispatch);
        if (route.layout) {
            children = undefined;
        }
        return {
            path: route.index ? undefined : route.layout ? route.path + "/*" : route.path,
            name: route.name,
            meta: route.meta,
            cache: isNil(route.cache) ? isNil(route.children) : route.cache,
            index: route.index,
            layout: route.layout,
            element: /*#__PURE__*/ _jsx(RouteProvider, {
                value: {
                    name: route.name,
                    code: (_route_meta = route.meta) === null || _route_meta === void 0 ? void 0 : _route_meta.code,
                    roleMenuResourceDtoList: (_route_meta1 = route.meta) === null || _route_meta1 === void 0 ? void 0 : _route_meta1.roleMenuResourceDtoList
                },
                children: /*#__PURE__*/ _jsx(route.component, {
                    name: route.name,
                    dispatch: dispatch,
                    route: route.layout ? route : undefined
                })
            }),
            children
        };
    }, routes);
}
export function getLatchRouteByEle(ele) {
    const data = ele === null || ele === void 0 ? void 0 : ele.props.value;
    const matches = data.matches;
    return isNil(data.outlet) ? matches : getLatchRouteByEle(data.outlet);
}
export function updateBodyTitle(matchRoutes) {
    const titles = reduce((title, data)=>{
        const route = data === null || data === void 0 ? void 0 : data.route;
        if (route.meta && route.meta.title) {
            title.push(route.meta.title);
        }
        return title;
    }, [], matchRoutes);
    if (isEmpty(titles)) {
        document.title = "蓝深科技业务中台";
    } else {
        document.title = titles.join("-");
    }
}
